import {atomFamily, atomWithStorage} from 'jotai/utils';
import {useAtom} from 'jotai';
import Storage from 'Services/Storage';

const atomStorage = {
    getItem: (key: string) => Storage.get<string>(key),
    setItem: (key: string, val: any) => Storage.set(key, val),
    removeItem: (key: string) => Storage.remove(key),
};

export const storageAtom = atomFamily(
    ({key, initialValue}: {key: string; initialValue: string}) =>
        atomWithStorage(key, initialValue, atomStorage),
    (arg1, arg2) => arg1.key === arg2.key,
);

export default function useStorage(key: string, initialValue?: string) {
    return useAtom(storageAtom({key, initialValue: initialValue || ''}));
}
